import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "hotel/home-stats";

class HomeStatsService {
  getStats() {
    return axios.get(ENDPOINT_URL, { headers: authHeader() });
  }
}

export default new HomeStatsService();
